/**
 *
 * @param id
 * @returns {*}
 */
export function resetScore(id) {
    return axios({
        url: '/api/partners/' + id + '/reset-score',
        method: 'post',
    });
}

export function getPartners(query = {}) {
    return axios({
        url: `/api/partners`,
        method: 'get',
        params: query
    });
}

export function getPartner(id) {
    return axios({
        url: `/api/partners/${id}`,
        method: 'get',
    });
}

export function getLendingInfo() {
    return axios({
        url: `/api/partners/lending-info`,
        method: 'get',
    });
}

/**
 *
 * @param userId
 * @param amount
 * @returns {*}
 */
export function accountTopUpClient(userId, amount) {
    return axios({
        url: '/api/partners/' + userId + '/account-top-up',
        method: 'post',
        data: {
            amount: amount
        }
    });
}


/**
 *
 * @param userId
 * @param amount
 * @returns {*}
 */
export function accountWithdrawalPartner(userId, amount) {
    return axios({
        url: '/api/partners/' + userId + '/account-withdrawal',
        method: 'post',
        data: {
            amount: amount
        }
    });
}

/**
 *
 * @returns {*}
 * @param data
 */
export function save(data) {
    return axios({
        url: '/api/partners',
        method: 'post',
        data:data
    });
}

/**
 *
 * @param userId
 * @param data
 * @returns {*}
 */
export function update(userId, data) {
    let isFormData = data instanceof FormData;
    return axios({
        url: '/api/partners/' + userId,
        method: isFormData ? 'post' : 'put',
        data: data,
        params: isFormData ? { _method: 'put' } : {}
    });
}

/**
 *
 * @param userId
 * @param limit
 * @returns {*}
 */
export function changeLimit(userId, limit) {
    return axios({
        url: '/api/partners/' + userId + '/change-limit',
        method: 'post',
        data: {
            limit: limit
        }
    });
}

export function changePenaltySetting(userId, status, commission) {
    return axios({
        url: '/api/partners/' + userId + '/penalty-setting',
        method: 'post',
        data: {
            isActive: status,
            commission: commission
        }
    });
}

export function deletePartner(id) {
    return axios({
        url: `/api/partners/${id}`,
        method: 'delete',
    });
}

export function restorePerson(id) {
    return axios({
        url: `/api/partners/${id}/restore`,
        method: 'post',
    });
}

export function getLendingSetupStatus(id) {
    return axios({
        url: `/api/partners/${id}/lending-setup-status`,
        method: 'get',
    });
}

export function checkSubdomain(subdomain, customDomain = null, userId = null) {
    return axios({
        url: `/api/partners/check-subdomain`,
        method: 'get',
        params: { subdomain, custom_domain: customDomain, user_id: userId }
    });
}
